export const regexTextMarkdown = '{{([^}]+)}}';
